import { action, makeObservable, observable } from 'mobx';
import { EntryLongList } from '@patient/store/entry/EntryLongList';

export enum LoaderType {
    Actual = 'actual',
    Today = 'today',
    Unsigned = 'unsigned',
    Draft = 'draft',
    WithoutService = 'withoutService',
    Reviewed = 'reviewed',
}

export class EntriesPageStore {
    public static Name = 'entriesPageStore' as const;
    @observable public selectedData: LoaderType = LoaderType.Actual;

    @observable public actualEntryList = new EntryLongList();
    @observable public todayEntryList = new EntryLongList();
    @observable public unsignedEDSEntryList = new EntryLongList();
    @observable public draftsEntryList = new EntryLongList();
    @observable public withoutRenderedServiceEntryList = new EntryLongList();
    @observable public reviewedEntryList = new EntryLongList();

    public constructor() {
        makeObservable(this);
    }

    @action
    public setSelectedData(data: LoaderType) {
        this.selectedData = data;
    }
}

export const entriesPageStore = new EntriesPageStore();
